// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as SettingsDDefault } from '../../../../../ui-v3/src/assets/icons/default/general/settings-d.svg?react';
import { ReactComponent as SettingsDSolid } from '../../../../../ui-v3/src/assets/icons/solid/general/SETTINGS-D.svg?react';
import { createIcons } from '../../Icon';
const SettingsDIcon = /* @__PURE__ */ createIcons('SettingsD', {
    default: SettingsDDefault,
    solid: SettingsDSolid
});
SettingsDIcon.supportedTypes = [
    'default',
    'solid'
];
SettingsDIcon.category = 'general';
export default SettingsDIcon;
